var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"locale-switch",attrs:{"items":_vm.locales,"hide-details":"","dark":""},on:{"change":_vm.changeLocale},model:{value:(_vm.currentLocale),callback:function ($$v) {_vm.currentLocale=$$v},expression:"currentLocale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }